/*--------------------------------------------------------------------------*
 * モーダル
 *--------------------------------------------------------------------------*/
module Module_Modal {
	import Model_Checkbox = Module_Checkbox.Model_Checkbox;

	interface inputProp {
		name: string,
		type: string,
		prop?: string|boolean[]
	}

	interface idProp {
		id: string,
		prop: boolean
	}

	export class Model_Modal {
		tab: JQuery;
		clsBtn: JQuery;
		sbmtBtn: JQuery;

		constructor() {
			this.tab     = $('[data-modal="tab"]');
			this.clsBtn  = $('[data-modal="close"]');
			this.sbmtBtn = $('[data-form="submit-btn"]');
		}

		// 背面スクロールの禁止
		stopBodyScroll(scrlTop): void {
			$("body").css({
				width: "100%",
				position: "fixed",
				top: -scrlTop,
			});
		}

		// 背面スクロールの解除
		resetBodyScroll(scrlTop: number): void {
			$("body").removeAttr("style");
			$("body, html").scrollTop(scrlTop);
		}

		// グループごとに親子関係のチェック状況を取得
		saveByGroupParentChildArr(groupName: string, parentName: string, childName: string): {parent: boolean, children: boolean[]}[] {
			const group: JQuery    = $(groupName);
			let checkArr: {parent: boolean, children: boolean[]}[] = [],
				i: number       = 0;
			group.each(function(): void {
				const _self: JQuery  = $(this),
					parent: JQuery   = _self.find(parentName),
					children: JQuery = _self.find(childName);
				checkArr[i] = {
					"parent" : parent.prop("checked"),
					"children": [],
				};
				children.each(function(): void {
					checkArr[i].children.push($(this).prop("checked"));
				});
				i++;
			});
			return checkArr;
		}

		// 配列をもとにチェック状況を復元
		resetByGroupParentChildArr(savedArr, groupName: string, parentName: string, childName: string): void {
			const group: JQuery = $(groupName);
			group.each(function(i): void {
				const _self: JQuery  = $(this),
					parent: JQuery   = _self.find(parentName),
					children: JQuery = _self.find(childName);
				parent.each(function(j: number): void {
					$(this).prop("checked", savedArr[i].parent);
				});
				children.each(function(k: number): void {
					$(this).prop("checked", savedArr[i].children[k]);
				});
			});
		}

		// name値からIDとチェック状況の取得
		getIdAndPropByName(name: string): idProp[] {
			const checkbox: JQuery = $('[name="'+name+'"]');
			let propArr: idProp[] = [];
			checkbox.each(function(i): void {
				const _self: JQuery = $(this);
				propArr[i] = {
					id: _self.attr("id"),
					prop: _self.prop("checked"),
				}
			});
			return propArr;
		}

		// チェック状況の復元
		resetPropById(arr: idProp[], name: string): void {
			// すべてのチェックを解除
			$('[name="'+name+'"]').prop("checked", false);

			// チェックが付いていたものに付与
			$.each(arr, function(i, args): void {
				$("#"+args.id).prop("checked", args.prop);
			});
		}

		// チェック状況の取得
		getPropList(nameArr: string[]): inputProp[] {
			if(nameArr) {
				const viewClass: this = this;
				let returnArr: inputProp[] = [];
				$.each(nameArr, function(i: number, name: string): void {
					const elm: JQuery = $('[name="'+name+'"]'),
						type: string = elm.attr("type") ? elm.attr("type") : elm[0].localName;
					returnArr[i] = {
						"name": name,
						"type": type,
						"prop": null
					}
					switch(type) {
						case "text":
						case "select":
							returnArr[i].prop = viewClass.getValByName(name);
							break;
						case "checkbox":
						case "radio":
							returnArr[i].prop = viewClass.getPropByName(name);
							break;
					}
				});
				return returnArr;
			}
		}

		// Name値からvalueを返す
		getValByName(name: string): string {
			return $('[name="'+name+'"]').val();
		}

		// チェックボックス・ラジオボタンのプロパティを返す
		getPropByName(name: string): boolean[] {
			let checkArr: boolean[] = [];
			$('[name="'+name+'"]').each(function(): void {
				checkArr.push($(this).prop("checked"));
			});
			return checkArr;
		}

		// モーダルを開く
		modalOpen(tab: JQuery, scrlTop: number, callback?: callbackType): void {
			const pnlWrap: JQuery   = $("#"+tab.attr("aria-describedby")),
				duration: number = 400;

			callback = callback ? callback : function(){};

			// モーダルの表示
			pnlWrap.attr('aria-hidden', "false");

			// 背面スクロールの禁止
			this.stopBodyScroll(scrlTop);

			// callback関数の実行
			setTimeout(callback, duration);
		}

		// モーダルを閉じる
		modalClose(tab: JQuery, scrlTop: number, callback?: callbackType): void {
			const modal: JQuery   = tab.parents('[data-modal="panel"]'),
				duration: number = 400;

			callback = callback ? callback : function(){};

			// モーダルの非表示
			modal.attr('aria-hidden', "true");

			// 背面スクロールの解除
			this.resetBodyScroll(scrlTop);

			// callback関数の実行
			setTimeout(callback, duration);
		}

		// 選択した地域をセット
		setAreaList(): void {
			const checkbox: Model_Checkbox = new Model_Checkbox(),
				prefs     : JQuery = $('[data-check="pref"]').not('[data-check="pref"]:disabled'),
				radiusEl  : JQuery = $('[name="radius"]:checked'),
				radiusVal : number = radiusEl.length ? Number(radiusEl.val()) : 0,
				outputArea: JQuery = $('[data-check="output"]'),
				defaultTxt: string = "指定なし";

			outputArea.empty();

			$.fn.getLabelTxt = function(): string {
				const _self: JQuery   = $(this);
				let returnTxt: string = "",
					oldParentVal: string;

				_self.each(function(): boolean|void {
					const _self: JQuery = $(this),
						parent: JQuery  = _self.parents('[data-check="group"]').prev().find('[data-check="parent"]');
					let labelTxt: string = $('[for="'+_self.attr("id")+'"]').text();
					// チェックがついていない or ラベルにテキストが無いときはスルー
					if(!_self.prop("checked") || !labelTxt) return true;

					// 親チェックが存在し、チェックされているとき
					if(parent.length && parent.prop("checked") === true) {
						// 1件目のとき、勤務地をセット
						if(parent.val() !== oldParentVal) {
							labelTxt = $('[for="'+parent.attr("id")+'"]').text();
							labelTxt = labelTxt.replace(/\s\((\d|,|件)+\)/, "");
							returnTxt += returnTxt ? "､" : "";
							returnTxt += labelTxt;
							oldParentVal = parent.val();
						}
						// 2件目以降はセットしない
					} else { // 親チェックが存在しないとき or 親チェックがされていないとき
						labelTxt = labelTxt.replace(/\s\((\d|,|件)+\)/, "")
						returnTxt += returnTxt ? "、" : "";
						returnTxt += labelTxt;
					}

				});

				return returnTxt;
			}

			if (radiusVal > 0) {
				outputArea.text(`${radiusVal}km`)
			}

			prefs.each(function(): void {
				const _self: JQuery    = $(this),
					prefName: string   = _self.next('[data-check="pref-name"]').text(),
					prefPnl: JQuery    = $("#"+_self.attr("aria-describedby")),
					cLocations: JQuery = prefPnl.find('[data-check="child"]').not('[data-check="child"]:disabled'),
					checkCount: number = checkbox.countChecks(cLocations);

				if(checkCount === cLocations.length && cLocations.length !== 0) { // 都道府県内すべて
					const pref = $('<span class="c-searchbox__selected__pref"></span>').text(prefName);
					if(outputArea.text()) {
						outputArea.append("、");
					}
					outputArea.append(pref);
				} else { // 都道府県内すべて以外
					if(checkCount !== 0) { // 都道府県内にチェックが1つでも存在するとき
						const outputPref = $('<span class="c-searchbox__selected__pref"></span>').text(prefName+"："),
							outputCity = $('<span class="c-searchbox__selected__city"></span>').text(cLocations.getLabelTxt());
						if(outputPref && outputCity) {
							if(outputArea.text()) {
								outputArea.append("、");
							}
							outputArea.append(outputPref, outputCity);
						}
					}
				}
			});

			if(outputArea.text() === "") {
				outputArea.text(defaultTxt);
			}
		}

		// チェック状況を取得（距離）
		saveRadiusList(): idProp[] {
			return this.getIdAndPropByName("radius");
		}

		// 選択した地域をリセット（勤務地）
		resetRadiusList(radiusListArr: idProp[]) {
			this.resetPropById(radiusListArr, "radius");
		}

		// チェック状況を取得（勤務地）
		saveAreaList(): idProp[] {
			return this.getIdAndPropByName("city_id[]");
		}

		// 選択した地域をリセット（勤務地）
		resetAreaList(areaListArr: idProp[]): void {
			this.resetPropById(areaListArr, "city_id[]");
		}

		// チェック状況を取得（詳細条件）
		saveOtherList(): inputProp[] {
			if(!$("body").hasClass("p-job_search_result")) return;

			const propArr: inputProp[] = this.getPropList([
				"income",
				"business_type[]",
				"commitment[]",
				"freeword",
			]);

			return propArr;
		}

		// 選択した条件をリセット（詳細条件）
		resetOtherList(otherListArr: any[]): void {
			$.each(otherListArr, function(i: number, config: any): void {
				const elm: JQuery = $('[name="'+config.name+'"]');
				switch(config.type) {
					case "checkbox":
					case "radio":
						elm.each(function(i): void {
							$(this).prop("checked", config.prop[i]);
						});
						break;
					case "select":
					case "text":
						elm.val(config.prop);
						break;
				}
			});
		}
	}
}
